import { render, staticRenderFns } from "./NewslettersList.vue?vue&type=template&id=67d6c358&"
import script from "./NewslettersList.vue?vue&type=script&lang=js&"
export * from "./NewslettersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports